'use strict';
import { EwSiteApp } from '../../app/ewsiteapp';

EwSiteApp.requires.push('ui.bootstrap');

EwSiteApp.controller('EsoTprCtrl', [
  '$scope',
  '$http',
  '$filter',
  '$uibModal',     // was $modal
  '$log',
  '$timeout',
  '$window',
  function ($scope, $http, $filter, $uibModal, $log, $timeout, $window) {

    $scope.dataUrl = '';
    $scope.items = [];
    $scope.filtered_items = [];
    $scope.sortField = 'created';
    $scope.sortReverse = true;
    $scope.currentPage = 1;
    $scope.itemsPerPage = 20;
    $scope.totalItems = 0;
    $scope.numPages = undefined;
    $scope.filter = {};
    $scope.isFilters = false;

    $scope.is_eso_user = false;
    $scope.is_provider_user = false;
    $scope.is_office_user = false;

    $scope.loadData = function () {
      if ($scope.dataUrl !== '') {
        $http.get($scope.dataUrl)
          .then(function (response) {
            var data = response.data;

            if (typeof data.success !== 'undefined') {
              if (data.success) {
                if (angular.isDefined(data.list)) {
                  $scope.items = data.list;
                  $scope.totalItems = $scope.items.length;

                  $scope.is_eso_user = data.is_eso_user;
                  $scope.is_provider_user = data.is_provider_user;
                  $scope.is_office_user = data.is_office_user;
                }
              } else if (angular.isDefined(data.message)) {
                $scope.ewMessages.add(data.message);
              }

              if (angular.isDefined(data.debug)) {
                $log.debug(data.debug);
              }
            }
          })
          .catch(function (err) {
            // optional: surface a friendly error
            $log.error('Failed to load dataUrl:', err);
          });
      }
    };

    $scope.getPageList = function () {
      var ordered = $filter('filter')($scope.items, $scope.filter);
      $scope.totalItems = ordered.length;
      ordered = $filter('orderBy')(ordered, $scope.sortField, $scope.sortReverse);
      var start = ($scope.currentPage - 1) * $scope.itemsPerPage;
      var end = start + $scope.itemsPerPage;
      return ordered.slice(start, end);
    };

    $scope.cleanFilters = function () {
      $scope.filter = {
        car_id: ''
      };
      $scope.setFilters();

      $timeout(function () {
        if (angular.element('#car_filter').length) {
          angular.element('#car_filter').val('').trigger('change');
        }
      }, 200);
    };

    $scope.setFilters = function () {
      $scope.isFilters = false;
      for (var k in $scope.filter) {
        if ($scope.filter.hasOwnProperty(k) && $scope.filter[k] !== '') {
          $scope.isFilters = true;
        }
      }
    };

    $scope.goToLocation = function (url) {
      $window.location.href = url;
    };

    // init select2 after render
    $timeout(function () {
      if (angular.element('#car_filter').length) {
        angular.element('#car_filter').select2({
          // "minimumResultsForSearch": -1
        });
      }
    }, 200);
  }
]).directive('transportsList', function () {
  return {
    restrict: 'A',
    link: function (scope, element, attr) {
      scope.dataUrl = '';
      scope.itemsPerPage = 20;

      if (angular.isDefined(attr.dataUrl) && attr.dataUrl !== '') {
        try {
          scope.dataUrl = decodeURIComponent(attr.dataUrl);
        } catch (e) {
          // fallback if attr was not encoded
          scope.dataUrl = attr.dataUrl;
        }
      }

      if (attr.itemsPerPage && attr.itemsPerPage !== '' && parseInt(attr.itemsPerPage, 10) > 0) {
        scope.itemsPerPage = parseInt(attr.itemsPerPage, 10);
      }

      scope.loadData();
    }
  };
});
